import React from 'react';
import ReactDOM from 'react-dom';

interface PinpadModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
}

const PinpadModal: React.FC<PinpadModalProps> = ({ isOpen, onClose, children, title }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div 
      className="fixed inset-0 bg-black/80 flex justify-center items-center z-50 p-4 select-none"
      onClick={onClose}
    >
      <div 
        className="bg-gray-100 dark:bg-gray-800 rounded-2xl shadow-2xl w-auto flex flex-col max-h-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-6 pb-4 flex-shrink-0">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white truncate pr-4">{title}</h2>
          <button onClick={onClose} className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors text-4xl leading-none flex-shrink-0">&times;</button>
        </div>
        <div className="overflow-y-auto p-6 pt-2 text-gray-900 dark:text-white">
            {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PinpadModal;